import React from 'react';
import { colors } from '../constants';

const User = ({ color, height, width }) => (
  <svg
    height={height}
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M10.249 10.5c-2.93 0-5.366 2.394-5.708 5.5h11.418c-.341-3.107-2.778-5.5-5.71-5.5zm0-1.5v1.5V9zM13 6.25a2.75 2.75 0 1 0-5.5 0 2.75 2.75 0 0 0 5.5 0zm4.5 10.5v.75H3v-.75c0-3.26 1.887-6.062 4.568-7.203a4.25 4.25 0 1 1 5.364 0C15.614 10.69 17.5 13.49 17.5 16.75z"
        id="user-icon-a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="user-icon-b" fill={colors.white}>
        <use xlinkHref="#user-icon-a" />
      </mask>
      <use fill={color} fillRule="nonzero" xlinkHref="#user-icon-a" />
      <g mask="url(#user-icon-b)" fill={color}>
        <path d="M0 0h20v19.989H0z" />
      </g>
    </g>
  </svg>
);

User.defaultProps = {
  color: colors.mediumGrey,
  height: 20,
  width: 20,
};

User.displayName = 'User';

export default User;
